module.exports = __webpack_public_path__ + "static/media/hk-vitebsk.7e77e940.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/hk-vitebsk.svg
// module id = 531
// module chunks = 0